import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const BAR_PROGRESS_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setValue", "clearValue"],
}
